import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { SplitText } from "gsap/SplitText";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { prefersReducedMotion } from "@/utils/media";

gsap.registerPlugin(ScrollTrigger, CustomEase, SplitText, Draggable, InertiaPlugin);

const defaults = {
  ease: "expo.out",
  duration: 1.2,
};

gsap.defaults(defaults);

const reduced = prefersReducedMotion();

export default gsap;
export { defaults, reduced, ScrollTrigger, SplitText, CustomEase, Draggable, InertiaPlugin };
